import { SelectProps } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelCheck from '../../../../../components/extras/SidePanelCheck';
import TableChecks from '../../../../../components/tables/tableChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemCheck } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


const pageSize = 10;

export const EDVChecksMyEvalsPage = () => {
    const { menu, idUser } = useGlobalState();

    const [cancelReason, setCancelReason] = useState("");
    const [sideOpen, setSideOpen] = useState(false);
    const [selectedStatusOption, setSelectedStatusOption] = useState<SelectProps.Option | null>(null);
    const mountedRef = useRef(false);


    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) {
                if (!mountedRef.current) {
                    handleCheckMine();
                    mountedRef.current = true;
                }
                handleCheckGet(parseInt(id))
            } else {
                setCheck(undefined)
                handleCheckMine();
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);



    const [check, setCheck] = useState<ItemCheck>();
    const [mychecks, setMychecks] = useState<ItemCheck[]>([]);





    const handleCheckMine = async () => {
        try {
            setCheck(undefined)
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/instruction/requests/search',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    pending: true,
                    orderBy: "dateSubmited",
                    order: "desc",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setMychecks(data.checks);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);

        } finally { setLoading(false) }
    }

    const handleCheckGet = async (idRequest: Number) => {
        try {
            setCheck(undefined)
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/instruction/requests/request',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idRequest: idRequest
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();

            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setCheck(data.check);
                //setSelectedStatusOption(statusOptions.find(option => Number(option.value) === data.check.statusRequest) || null);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const handleCheckEval = (idCheckParameter: string, opt: any) => {
        if (check && check.statusRequest == 1 && check.idInstructor == idUser) {
            const updatedJsonResults = check.jsonResults.map((item: any) =>
                item.idCheckParameter === idCheckParameter
                    ? { ...item, resultValue: opt.value, resultText: opt.text }
                    : item
            );
            setCheck((prev: any) => ({
                ...prev,
                jsonResults: updatedJsonResults
            }));

            // 3. Send the NEWly calculated array to the API
            // Now you aren't waiting for the state to update!
            handleUpdateParameters({ idRequest: check.idRequest, jsonResults: updatedJsonResults });
        }
    };
    useEffect(() => {
        if (check && check.jsonResults) {
            //handleUpdateEval()
        }
    }, [check?.jsonResults]);



    const handleUpdateParameters = async (checkData: any) => {
        try {
            const chk = {
                idRequest: checkData.idRequest,
                jsonResults: checkData.jsonResults,
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/instruction/request/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(chk),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();

            //addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.checks) {
                    setMychecks(data.checks);
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleUpdateEval = async (check: ItemCheck) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/instruction/request/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idRequest: check?.idRequest,
                    jsonResults: check?.jsonResults,
                    result: check?.result,
                    statusRequest: check.statusRequest ?? 0,
                    dateResult: check.dateResult ?? "",
                    //statusRequest: Number(selectedStatusOption?.value),
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.checks) {
                    //setMychecks(data.checks);
                    window.location.hash = "edv/checks/myevals"
                }
                setCheck(undefined);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    type Tab = {
        label: string;
        id: string;
        content: React.ReactNode;
    };
    const isValid = !(selectedStatusOption?.value === "1" ||
        (check?.jsonResults?.every(item => item.resultValue !== "") ?? false));

    const updateEnable = () => {
        check.jsonResults
    }
    const statusOptions = [
        { label: "Pendiente", value: "1", description: "Chequeo se actualiza, pero no se cierra definitivamente, puede continuar editandolo más tarde" },
        { label: "Aprobado", value: "3" },
        { label: "Aprobado *", value: "4", description: "con temas a resolver" },
        { label: "Reprobado", value: "2" },
        { label: "Anular", value: "-1" },
    ];
    const currentSelectedOption = statusOptions.find(
        option => Number(option.value) === check?.statusRequest
    );

    // 2. Default if not found (optional, but good practice)
    const selectedOptionValue = currentSelectedOption || { label: "Seleccionar estado", value: null };
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={check !== undefined}

            onSplitPanelToggle={({ detail }) => {
                !detail.open ? window.location.hash = "edv/checks/myevals" : null
            }}
            splitPanelSize={600}
            splitPanel={
                <SidePanelCheck editEval={check && check.idInstructor === idUser} Check={check} onUpdateEval={(updatedCheck) => {
                    console.log(updatedCheck)
                    handleUpdateParameters(updatedCheck);
                }}
                    onUpdateCheck={(updatedCheck) => {
                        handleUpdateEval(updatedCheck);
                    }}
                />
            }

            contentType="form"
            breadcrumbs={
                < BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                            description="Chequeos pendientes de evaluación asignados a mi como instructor"
                        //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Mis chequeos pendientes
                        </Header>

                        <SpaceBetween direction='vertical' size='xs'>
                            {mychecks && (
                                <TableChecks checks={mychecks} onSelect={(item: ItemCheck) => window.location.hash = `edv/checks/myevals?id=${item.idRequest}`}
                                    showInstructor={false}
                                    showStatus={false} showEval
                                />
                            )}
                        </SpaceBetween>
                    </SpaceBetween>



                </>
            }
        />
    );
};

function getColor(hex: string): "green" | "blue" | "red" | "grey" | "light" {
    switch (hex.toLowerCase()) {
        case "#00b000":
            return "green";
        case "#007cff":
            return "blue";
        case "#ff0000":
            return "red";
        case "#999999":
            return "grey";
        default:
            return "grey";
    }
}